/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Keyword_Optimizer_Toast_AcceptedInputs */

const en_keyword_optimizer_toast_accepted = /** @type {(inputs: Keyword_Optimizer_Toast_AcceptedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suggestion accepted — applied to your resume`)
};

const de_keyword_optimizer_toast_accepted = /** @type {(inputs: Keyword_Optimizer_Toast_AcceptedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vorschlag akzeptiert — auf deinen Lebenslauf angewendet`)
};

const fr_keyword_optimizer_toast_accepted = /** @type {(inputs: Keyword_Optimizer_Toast_AcceptedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suggestion acceptée — appliquée à votre CV`)
};

const es_keyword_optimizer_toast_accepted = /** @type {(inputs: Keyword_Optimizer_Toast_AcceptedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sugerencia aceptada — aplicada a tu currículum`)
};

const it_keyword_optimizer_toast_accepted = /** @type {(inputs: Keyword_Optimizer_Toast_AcceptedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suggerimento accettato — applicato al tuo CV`)
};

const nl_keyword_optimizer_toast_accepted = /** @type {(inputs: Keyword_Optimizer_Toast_AcceptedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suggestie geaccepteerd — toegepast op je CV`)
};

const pl_keyword_optimizer_toast_accepted = /** @type {(inputs: Keyword_Optimizer_Toast_AcceptedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sugestia zaakceptowana — zastosowana w Twoim CV`)
};

const fi_keyword_optimizer_toast_accepted = /** @type {(inputs: Keyword_Optimizer_Toast_AcceptedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ehdotus hyväksytty — sovellettu ansioluetteloosi`)
};

const da_keyword_optimizer_toast_accepted = /** @type {(inputs: Keyword_Optimizer_Toast_AcceptedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Forslag accepteret — anvendt på dit CV`)
};

const sv_keyword_optimizer_toast_accepted = /** @type {(inputs: Keyword_Optimizer_Toast_AcceptedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Förslag godkänt — tillämpat på ditt CV`)
};

/**
* | output |
* | --- |
* | "Suggestion accepted — applied to your resume" |
*
* @param {Keyword_Optimizer_Toast_AcceptedInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const keyword_optimizer_toast_accepted = /** @type {((inputs?: Keyword_Optimizer_Toast_AcceptedInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Keyword_Optimizer_Toast_AcceptedInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_keyword_optimizer_toast_accepted(inputs)
	if (locale === "fr") return fr_keyword_optimizer_toast_accepted(inputs)
	if (locale === "es") return es_keyword_optimizer_toast_accepted(inputs)
	if (locale === "it") return it_keyword_optimizer_toast_accepted(inputs)
	if (locale === "nl") return nl_keyword_optimizer_toast_accepted(inputs)
	if (locale === "pl") return pl_keyword_optimizer_toast_accepted(inputs)
	if (locale === "fi") return fi_keyword_optimizer_toast_accepted(inputs)
	if (locale === "da") return da_keyword_optimizer_toast_accepted(inputs)
	if (locale === "sv") return sv_keyword_optimizer_toast_accepted(inputs)
	return en_keyword_optimizer_toast_accepted(inputs)
});